import { fetcher } from '@commenda/utils';
import { FileUploadPayload, FileUploadResponse } from './types';

export async function uploadSalesTaxFile(
  uploadData: FileUploadPayload
): Promise<{
  success: boolean;
  data?: FileUploadResponse;
  error?: string;
}> {
  try {
    const response = await fetcher(
      'new-sales-tax/file',
      {
        method: 'POST',
        body: uploadData,
      },
      undefined
    );

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: data.message || 'Failed to upload file',
      };
    }

    return {
      success: true,
      data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unexpected error occurred',
    };
  }
}
